import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useAppSelector } from '@ibk/shared-config';
import { useTranslation } from '@ibk/shared-translation';
import { ProductStatus } from '@ibk/shared-types';
import { formatCurrency, isEmptyObject } from '@ibk/shared-utils';
import { Icon } from '../../Icon';
import ProductCard from '../ProductCard';
export default function ContaPjCard({ id, status, onClick, 'data-testid': dataTestId, metaData, ...props }) {
    const { t } = useTranslation();
    const showBalance = useAppSelector(state => state.showBalance.showBalance);
    const icon = status === ProductStatus.CONTRACTED ? 'digitalAccountFilled' : 'digitalAccount';
    const title = t('products.conta-pj');
    const balance = typeof metaData?.balance?.amount === 'number'
        ? metaData.balance.amount
        : 0;
    const getBalanceValue = () => {
        if (!showBalance)
            return '*****';
        return formatCurrency(balance);
    };
    const getStatusElement = () => {
        if (status === ProductStatus.ANALYSIS) {
            return _jsx("span", { "data-testid": `product-card-analysis-${id}`, children: t('products.status.account-analysis') });
        }
        if (status === ProductStatus.NOT_APPROVED) {
            return _jsx("span", { "data-testid": `product-card-not-approved-${id}`, children: t('products.status.not-approved') });
        }
        if (status === ProductStatus.CONTRACTED && !isEmptyObject(metaData)) {
            return (_jsxs(_Fragment, { children: [t('products.status.balance'), _jsxs("strong", { "data-testid": `product-card-contracted-data-${id}`, children: ["\u00A0", getBalanceValue()] })] }));
        }
        return null;
    };
    const statusElement = getStatusElement();
    return (_jsx(ProductCard, { ...props, id: id, title: title, icon: _jsx(Icon, { name: icon }), status: status, onClick: onClick, "data-testid": dataTestId ?? `contabilidade-digital-card-${id}`, statusElement: statusElement }));
}
